/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const shapeEnumSchema = z
	.enum(["pill", "ribbon", "sticker", "icon_only", "inherit"])
	.describe("* `pill` - Пилюля\n* `ribbon` - Лента\n* `sticker` - Наклейка\n* `icon_only` - Только иконка\n* `inherit` - Как у всех");
